var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"sliderContainer",staticClass:"slider-container"},[_c('div',{ref:"slider",staticClass:"slider",on:{"click":_vm.click}},[_c('div',{ref:"bar",staticClass:"bar",style:({
        'width': _vm.left + '%'
      })}),_c('span',{ref:"circle",staticClass:"circle",class:{'no-data': _vm.valueLabel == 0},style:({
        'left': _vm.left + '%'
      }),on:{"mousedown":_vm.mousedown}})]),_c('span',{staticClass:"slider-number"},[_vm._v(_vm._s(_vm.label ? _vm.valueLabel : '')+" "),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }